import { parseSelection } from "@/components/discover/filters/selection";
import { FILTER_REGISTRY } from "@/components/discover/filters/config";
import { isFilterSetInUrl } from "@/components/discover/filters/discoverTabFilterUrl";
import { SPEC_FILTER_NAME_BY_KEY } from "@/components/discover/filters/specFilters";

export type DiscoverTab = "events" | "clubs";

export type ListingFilters = {
  date_filter: string | null;
  radius_filter: string | null;
  sort_filter: string | null;
  age_filter: string[];
  skill_filter: string[];
  price_filter: string[];
};

/** The listing filters a detail page reports, none of them set. */
export const NO_FILTERS: ListingFilters = {
  date_filter: null,
  radius_filter: null,
  sort_filter: null,
  age_filter: [],
  skill_filter: [],
  price_filter: [],
};

/** The registry keys each tab reads, named for the spec by `SPEC_FILTER_NAME_BY_KEY`. */
const FILTER_KEYS_BY_TAB = {
  events: [
    "date",
    "radius",
    "eventSort",
    "eventAgeGroup",
    "eventSkillLevel",
    "price",
  ],
  clubs: [
    "date",
    "radius",
    "clubSort",
    "ageGroup",
    "skillLevel",
    "membershipFee",
  ],
} as const satisfies Record<
  DiscoverTab,
  readonly (keyof typeof SPEC_FILTER_NAME_BY_KEY)[]
>;

/**
 * Only the filters the visitor set count, by the same rule as "Clear all"
 * (`isFilterSetInUrl`). An untouched filter stays `null` (single value) or `[]`
 * (several), even though the list shows its default.
 */
export function toListingFilters(
  searchParams: URLSearchParams,
  tab: DiscoverTab,
): ListingFilters {
  const selection = parseSelection(searchParams);
  const setFilters = FILTER_KEYS_BY_TAB[tab]
    .filter((key) => isFilterSetInUrl(searchParams, FILTER_REGISTRY[key]))
    .map(
      (key): [keyof ListingFilters, ListingFilters[keyof ListingFilters]] => [
        `${SPEC_FILTER_NAME_BY_KEY[key]}_filter`,
        selection[key],
      ],
    );

  return { ...NO_FILTERS, ...Object.fromEntries(setFilters) };
}
